import { QueryMeta } from "@tanstack/react-query";

export const CACHE_TIME_1_MONTH = 1000 * 60 * 60 * 24 * 30;
export const CACHE_TIME_1_WEEK = 1000 * 60 * 60 * 24 * 7;
export const CACHE_TIME_3_DAYS = 1000 * 60 * 60 * 24 * 3;
export const CACHE_TIME_24_HOURS = 1000 * 60 * 60 * 24;
export const CACHE_TIME_1_HOUR = 1000 * 60 * 60;
export const CACHE_TIME_30_MINUTES = 1000 * 60 * 30;
export const CACHE_TIME_10_MINUTES = 1000 * 60 * 10;
export const FIVE_SECONDS = 5000;

// Pagination
export const PAGINATION_LIMIT_4 = 4;

// NAKA COPIED
export const PAGINATION_LIMIT = 30;
export const PAGINATION_LIMIT_5 = 5;
export const PAGINATION_LIMIT_6 = 6;
export const PAGINATION_LIMIT_8 = 8;
export const PAGINATION_LIMIT_9 = 9;
export const PAGINATION_LIMIT_TABLE = 12;
export const PAGINATION_LIMIT_16 = 16;
export const PAGINATION_UNLIMITED = 1000;
export const PAGINATION_LIMIT_MOBILE = 9;
export const PAGINATION_PAGE = 1;
export const PAGINATION_OFFSET: number[] = [30, 60, 90, 120, 150];
export const PAGINATION_OFFSET_MOBILE: number[] = [9, 18, 27, 36, 45];
export const PAGINATION_OFFSET_GAME_STAT: number[] = [6, 12, 18, 24, 30];
export const PAGINATION_OFFSET_TABLE: number[] = [12, 24, 36, 48, 60];
export const PAGINATION_OFFSET_START_16: number[] = [16, 32, 48, 64, 80];
export const PAGINATION_TOTAL = 0;

export const IMAGE_QUALITY = 40;

/**
 * @description The default value for the `revalidate` option in the `fetch` method.
 */
// Cache for 3 minutes
export const REVALIDATE_3_MINUTES = 180;
// Cache for 5 minutes
export const REVALIDATE_5_MINUTES = 300;
// Cache for 30 minutes
export const REVALIDATE_30_MINUTES = 1800;
// Cache for 1 hour
export const REVALIDATE_1_HOUR = 3600;
// Cache for 1 day
export const REVALIDATE_1_DAY = 86400;
// Cache for 3 days
export const REVALIDATE_3_DAYS = 259200;
// Cache for 1 week
export const REVALIDATE_1_WEEK = 604800;
// Cache for 2 weeks
export const REVALIDATE_2_WEEKS = 1209600;
// Cache for 3 weeks
export const REVALIDATE_3_WEEKS = 1814400;
// Cache for 1 month
export const REVALIDATE_1_MONTH = 2592000;
// Cache for 2 months
export const REVALIDATE_2_MONTHS = 5184000;
// Cache for 3 months
export const REVALIDATE_3_MONTHS = 7776000;

/**
 * @description The default value for the `refetchInterval` option in the `fetch` method.
 */
// Every 5 seconds
export const REFETCH_INTERVAL_5_SECONDS = 5000; // 5 seconds = 5 * 1000 milliseconds
// Every 10 seconds
export const REFETCH_INTERVAL_10_SECONDS = 10000; // 10 seconds = 10 * 1000 milliseconds
// Every 30 seconds
export const REFETCH_INTERVAL_30_SECONDS = 30000; // 30 seconds = 30 * 1000 milliseconds

// Every 1 minute
export const REFETCH_INTERVAL_1_MINUTE = 60000; // 60 seconds = 60 * 1000 milliseconds

// Every 2 minutes
export const REFETCH_INTERVAL_2_MINUTES = 120000; // 120 seconds = 120 * 1000 milliseconds

// Every 5 minutes
export const REFETCH_INTERVAL_5_MINUTES = 300000; // 300 seconds = 300 * 1000 milliseconds

// Every 10 minutes
export const REFETCH_INTERVAL_10_MINUTES = 600000; // 600 seconds = 600 * 1000 milliseconds

// Socket
export const SOCKET_OPTIONS = {
  autoConnect: false,
  reconnection: true,
  secure: true,
  withCredentials: true,
  transports: ["websocket"],
};

export const DEFAULT_QUERY_SETTING: QueryMeta = {
  // Set the default cache time to 5 minutes
  staleTime: REVALIDATE_5_MINUTES,

  // Set the default refetch on window focus to false
  refetchOnWindowFocus: false,

  // Set the default refetch on mount to false
  refetchOnMount: false,

  // Set the default refetch on reconnection to false
  refetchOnReconnect: false,

  // Set the default retry to continue to false
  retry: 1,

  // Set the default refetch interval to false
  refetchInterval: false,

  // Set the default refetch interval background to false
  refetchIntervalInBackground: false,
};

export const DEFAULT_MUTATION_SETTING: QueryMeta = {
  retry: false,
  retryDelay: 200,
};

export const DEFAULT_AGENT_FILTER = {
  limit: PAGINATION_LIMIT_16,
  page: PAGINATION_PAGE,
  sort: -1,
  is_active: true,
  skip: 1,
};

export const INPUT_FILE_ACCESS = ".jpg, .jpeg, .png, .gif";
export const FILES_TYPES = ["image/jpeg", "image/png", "image/gif"];
export const FILE_4MB = 4 * 1024 * 1024;
